module.exports = __webpack_public_path__ + "static/media/podium.3aba4d14.svg";